module.exports = __webpack_public_path__ + "img/loading-spinner15.91d7a7c1.gif";